[
  {
    "id": 1,
    "expiration": "2025-12-10T22:00:00.000Z",
    "start": "2025-07-16T18:30:00.000Z",
    "name": "Formazione continua",
    "published_at": "2025-07-12T08:18:08.682Z",
    "created_at": "2025-07-12T08:18:04.970Z",
    "updated_at": "2025-07-12T09:17:13.086Z",
    "img": {
      "id": 65,
      "name": "FormazioneContinua2025.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1080,
      "height": 1350,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_FormazioneContinua2025.jpg",
          "hash": "thumbnail_Formazione_Continua2025_b2951b70f8",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 125,
          "height": 156,
          "size": 5.2,
          "path": null,
          "url": "/uploads/thumbnail_Formazione_Continua2025_b2951b70f8.jpg"
        },
        "large": {
          "name": "large_FormazioneContinua2025.jpg",
          "hash": "large_Formazione_Continua2025_b2951b70f8",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 800,
          "height": 1000,
          "size": 93.32,
          "path": null,
          "url": "/uploads/large_Formazione_Continua2025_b2951b70f8.jpg"
        },
        "medium": {
          "name": "medium_FormazioneContinua2025.jpg",
          "hash": "medium_Formazione_Continua2025_b2951b70f8",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 600,
          "height": 750,
          "size": 62.05,
          "path": null,
          "url": "/uploads/medium_Formazione_Continua2025_b2951b70f8.jpg"
        },
        "small": {
          "name": "small_FormazioneContinua2025.jpg",
          "hash": "small_Formazione_Continua2025_b2951b70f8",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 400,
          "height": 500,
          "size": 34.49,
          "path": null,
          "url": "/uploads/small_Formazione_Continua2025_b2951b70f8.jpg"
        }
      },
      "hash": "Formazione_Continua2025_b2951b70f8",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 104.75,
      "url": "/uploads/Formazione_Continua2025_b2951b70f8.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-12T08:17:37.966Z",
      "updated_at": "2025-07-12T08:17:37.975Z"
    }
  },
  {
    "id": 2,
    "expiration": "2025-07-31T21:00:00.000Z",
    "start": "2025-07-28T15:00:00.000Z",
    "name": "Corso tecnico scatola cognitiva",
    "published_at": "2025-07-12T08:18:55.767Z",
    "created_at": "2025-07-12T08:18:53.591Z",
    "updated_at": "2025-07-12T09:18:10.774Z",
    "img": {
      "id": 66,
      "name": "loca_corso_tecnico_scatola cognitiva2025.png",
      "alternativeText": "",
      "caption": "",
      "width": 1080,
      "height": 1350,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_loca_corso_tecnico_scatola cognitiva2025.png",
          "hash": "thumbnail_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a",
          "ext": ".png",
          "mime": "image/png",
          "width": 125,
          "height": 156,
          "size": 32.04,
          "path": null,
          "url": "/uploads/thumbnail_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a.png"
        },
        "large": {
          "name": "large_loca_corso_tecnico_scatola cognitiva2025.png",
          "hash": "large_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a",
          "ext": ".png",
          "mime": "image/png",
          "width": 800,
          "height": 1000,
          "size": 760.45,
          "path": null,
          "url": "/uploads/large_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a.png"
        },
        "medium": {
          "name": "medium_loca_corso_tecnico_scatola cognitiva2025.png",
          "hash": "medium_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a",
          "ext": ".png",
          "mime": "image/png",
          "width": 600,
          "height": 750,
          "size": 464.77,
          "path": null,
          "url": "/uploads/medium_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a.png"
        },
        "small": {
          "name": "small_loca_corso_tecnico_scatola cognitiva2025.png",
          "hash": "small_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a",
          "ext": ".png",
          "mime": "image/png",
          "width": 400,
          "height": 500,
          "size": 213.72,
          "path": null,
          "url": "/uploads/small_loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a.png"
        }
      },
      "hash": "loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a",
      "ext": ".png",
      "mime": "image/png",
      "size": 926.46,
      "url": "/uploads/loca_corso_tecnico_scatola_cognitiva2025_9669ca9c1a.png",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-12T08:18:34.528Z",
      "updated_at": "2025-07-12T08:18:34.538Z"
    }
  },
  {
    "id": 3,
    "expiration": "2025-08-04T21:00:00.000Z",
    "start": "2025-08-04T15:00:00.000Z",
    "name": "Minicorso bocca sicura",
    "published_at": "2025-07-12T08:20:41.879Z",
    "created_at": "2025-07-12T08:19:34.256Z",
    "updated_at": "2025-08-05T11:15:13.676Z",
    "img": {
      "id": 67,
      "name": "MINI CORSO BOCCA SICURA CAGLIARI AGOSTO 2025.png",
      "alternativeText": "",
      "caption": "",
      "width": 1080,
      "height": 1350,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_MINI CORSO BOCCA SICURA CAGLIARI AGOSTO 2025.png",
          "hash": "thumbnail_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1",
          "ext": ".png",
          "mime": "image/png",
          "width": 125,
          "height": 156,
          "size": 32.2,
          "path": null,
          "url": "/uploads/thumbnail_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1.png"
        },
        "large": {
          "name": "large_MINI CORSO BOCCA SICURA CAGLIARI AGOSTO 2025.png",
          "hash": "large_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1",
          "ext": ".png",
          "mime": "image/png",
          "width": 800,
          "height": 1000,
          "size": 742.17,
          "path": null,
          "url": "/uploads/large_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1.png"
        },
        "medium": {
          "name": "medium_MINI CORSO BOCCA SICURA CAGLIARI AGOSTO 2025.png",
          "hash": "medium_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1",
          "ext": ".png",
          "mime": "image/png",
          "width": 600,
          "height": 750,
          "size": 452.96,
          "path": null,
          "url": "/uploads/medium_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1.png"
        },
        "small": {
          "name": "small_MINI CORSO BOCCA SICURA CAGLIARI AGOSTO 2025.png",
          "hash": "small_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1",
          "ext": ".png",
          "mime": "image/png",
          "width": 400,
          "height": 500,
          "size": 207.08,
          "path": null,
          "url": "/uploads/small_MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1.png"
        }
      },
      "hash": "MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1",
      "ext": ".png",
      "mime": "image/png",
      "size": 891.88,
      "url": "/uploads/MINI_CORSO_BOCCA_SICURA_CAGLIARI_AGOSTO_2025_ee2cb021e1.png",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-12T08:19:25.056Z",
      "updated_at": "2025-07-12T08:19:25.073Z"
    }
  },
  {
    "id": 4,
    "expiration": "2025-09-27T19:00:00.000Z",
    "start": "2025-09-26T06:30:00.000Z",
    "name": "Tecnico della masticazione",
    "published_at": "2025-07-15T18:41:28.534Z",
    "created_at": "2025-07-15T18:39:10.498Z",
    "updated_at": "2025-07-28T15:07:58.220Z",
    "img": {
      "id": 70,
      "name": "TecnicoMasticazione.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1131,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_TecnicoMasticazione.jpg",
          "hash": "thumbnail_Tecnico_Masticazione_a629c0b9dc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 110,
          "height": 156,
          "size": 6.06,
          "path": null,
          "url": "/uploads/thumbnail_Tecnico_Masticazione_a629c0b9dc.jpg"
        },
        "large": {
          "name": "large_TecnicoMasticazione.jpg",
          "hash": "large_Tecnico_Masticazione_a629c0b9dc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 707,
          "height": 1000,
          "size": 102.71,
          "path": null,
          "url": "/uploads/large_Tecnico_Masticazione_a629c0b9dc.jpg"
        },
        "medium": {
          "name": "medium_TecnicoMasticazione.jpg",
          "hash": "medium_Tecnico_Masticazione_a629c0b9dc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 530,
          "height": 750,
          "size": 66.18,
          "path": null,
          "url": "/uploads/medium_Tecnico_Masticazione_a629c0b9dc.jpg"
        },
        "small": {
          "name": "small_TecnicoMasticazione.jpg",
          "hash": "small_Tecnico_Masticazione_a629c0b9dc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 353,
          "height": 500,
          "size": 36.95,
          "path": null,
          "url": "/uploads/small_Tecnico_Masticazione_a629c0b9dc.jpg"
        }
      },
      "hash": "Tecnico_Masticazione_a629c0b9dc",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 193.65,
      "url": "/uploads/Tecnico_Masticazione_a629c0b9dc.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-15T18:38:22.554Z",
      "updated_at": "2025-07-15T18:38:22.566Z"
    }
  },
  {
    "id": 5,
    "expiration": "2025-09-11T21:00:00.000Z",
    "start": "2025-09-10T10:00:00.000Z",
    "name": "Tecnico della masticazione vieni con me",
    "published_at": "2025-07-28T14:59:51.306Z",
    "created_at": "2025-07-28T14:40:41.864Z",
    "updated_at": "2025-08-05T11:48:21.240Z",
    "img": {
      "id": 73,
      "name": "TecnicoMasticazioneVieniConMe.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1080,
      "height": 1350,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_TecnicoMasticazioneVieniConMe.jpg",
          "hash": "thumbnail_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 125,
          "height": 156,
          "size": 6.5,
          "path": null,
          "url": "/uploads/thumbnail_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd.jpg"
        },
        "large": {
          "name": "large_TecnicoMasticazioneVieniConMe.jpg",
          "hash": "large_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 800,
          "height": 1000,
          "size": 143.26,
          "path": null,
          "url": "/uploads/large_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd.jpg"
        },
        "medium": {
          "name": "medium_TecnicoMasticazioneVieniConMe.jpg",
          "hash": "medium_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 600,
          "height": 750,
          "size": 92.32,
          "path": null,
          "url": "/uploads/medium_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd.jpg"
        },
        "small": {
          "name": "small_TecnicoMasticazioneVieniConMe.jpg",
          "hash": "small_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 400,
          "height": 500,
          "size": 47.08,
          "path": null,
          "url": "/uploads/small_Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd.jpg"
        }
      },
      "hash": "Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 221.16,
      "url": "/uploads/Tecnico_Masticazione_Vieni_Con_Me_b4bcb528fd.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-08-05T11:20:13.435Z",
      "updated_at": "2025-08-05T11:20:13.445Z"
    }
  },
  {
    "id": 6,
    "expiration": "2025-10-05T10:00:00.000Z",
    "start": "2025-10-04T04:30:00.000Z",
    "name": "Tecnico Masticazione Milano",
    "published_at": "2025-08-05T11:16:52.680Z",
    "created_at": "2025-08-05T11:16:49.314Z",
    "updated_at": "2025-08-06T07:31:56.022Z",
    "img": {
      "id": 74,
      "name": "TecnicoMasticazioneMilano.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1080,
      "height": 1350,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_TecnicoMasticazioneMilano.jpg",
          "hash": "thumbnail_Tecnico_Masticazione_Milano_cb87ed300f",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 125,
          "height": 156,
          "size": 9.07,
          "path": null,
          "url": "/uploads/thumbnail_Tecnico_Masticazione_Milano_cb87ed300f.jpg"
        },
        "large": {
          "name": "large_TecnicoMasticazioneMilano.jpg",
          "hash": "large_Tecnico_Masticazione_Milano_cb87ed300f",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 800,
          "height": 1000,
          "size": 151.9,
          "path": null,
          "url": "/uploads/large_Tecnico_Masticazione_Milano_cb87ed300f.jpg"
        },
        "medium": {
          "name": "medium_TecnicoMasticazioneMilano.jpg",
          "hash": "medium_Tecnico_Masticazione_Milano_cb87ed300f",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 600,
          "height": 750,
          "size": 103.21,
          "path": null,
          "url": "/uploads/medium_Tecnico_Masticazione_Milano_cb87ed300f.jpg"
        },
        "small": {
          "name": "small_TecnicoMasticazioneMilano.jpg",
          "hash": "small_Tecnico_Masticazione_Milano_cb87ed300f",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 400,
          "height": 500,
          "size": 57.48,
          "path": null,
          "url": "/uploads/small_Tecnico_Masticazione_Milano_cb87ed300f.jpg"
        }
      },
      "hash": "Tecnico_Masticazione_Milano_cb87ed300f",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 227.23,
      "url": "/uploads/Tecnico_Masticazione_Milano_cb87ed300f.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-08-06T07:31:50.739Z",
      "updated_at": "2025-08-06T07:31:50.749Z"
    }
  }
]